<template>
  <v-container fluid class="fill-height d-block">
    <div class="fill-width pa-2 fill-height d-block">
      <LoadingComponent v-if="loading" />
      <v-row
        v-else
        class="fill-width flex-column ma-0"
        align="center"
        justify="center"
      >
        <v-icon size="80" contain>mdi-account</v-icon>
        <v-card-title class="pt-0"
          >{{
            $t(
              "panel.businesses.businessesList.gateway.gatewayDetailsPage.title"
            )
          }}
          {{ gatewayDetails.gatewayType }}</v-card-title
        >
        <div
          v-if="gatewayDetails.lastUpdate || gatewayDetails.registeredDate"
          class="fill-width"
        >
          <div
            v-if="gatewayDetails.lastUpdate"
            class="d-flex align-center justify-space-between pa-3"
          >
            <div class="width-auto pe-1">
              {{
                $t(
                  "panel.businesses.businessesList.gateway.gatewayDetailsPage.lastUpdate"
                )
              }}
            </div>
            <div class="width-auto text-truncate">
              {{ gatewayDetails.lastUpdate | $renderDate }}
            </div>
          </div>
          <div v-else class="d-flex align-center justify-space-between pa-3">
            <div class="width-auto pe-1">
              {{
                $t(
                  "panel.businesses.businessesList.gateway.gatewayDetailsPage.registeredDate"
                )
              }}
            </div>
            <div class="width-auto text-truncate">
              {{ gatewayDetails.registeredDate | $renderDate }}
            </div>
          </div>
          <v-divider class="mx-3 gateway-divider" />
        </div>
        <!--        <template v-for="data in gatewayDetails.gatewayCurrencies">-->
        <template v-for="data in gatewayDetails.data">
          <div :key="data.iso + data.network" class="fill-width gateway-info">
            <div class="d-flex align-center justify-center pa-3">
              {{ data.iso }} ({{ data.network }})
            </div>
            <v-divider class="mx-3 gateway-divider" />
          </div>
        </template>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { merchantService } from "@/services";
import renderDate from "@/mixins/renderDate";
import LoadingComponent from "@/components/Common/Loading";

export default {
  name: "gateway-details",
  components: { LoadingComponent },
  props: ["gatewayId"],
  mixins: [renderDate],
  data() {
    return {
      userInfo: {},
      loading: false,
      gatewayDetails: []
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      merchantService
        .getGatewayCurrencyDetails(this.gatewayId)
        .then(response => {
          this.gatewayDetails = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "GatewayDetails";
</style>
